import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { COLUMN_WIDTH_100 } from '@modules/page-builder/config/column-constants';

export const PADDING_TOP_BOTTOM_SECTION = 120;
// export const PADDING_TOP_BOTTOM_SECTION_MOBILE = 30;
export const PADDING_LEFT_RIGHT_SECTION = 50;
// export const PADDING_LEFT_RIGHT_SECTION_MOBILE = 18;
export const MODAL_BOX_SHADOW = `0px 14px 24px 2px rgba(0, 0, 0, 0.08)`;

export const PADDING_TOP_CAPTION_MOBILE = 16;
export const PADDING_TOP_CAPTION = 16;

// export const SingleColumnContainer: StyleRule = () => ({
//     display: 'flex',
//     flexFlow: 'column',
// });

// export const DoubleColumnContainer: StyleRule = ({ theme }) => ({
//     display: 'flex',
//     flexFlow: 'column',
//     margin: '0 auto',
//     position: 'relative',
//     '& > div': {
//         margin: `${pxToRem(ROW_GAP_MOBILE)} auto 0`,
//         width: '100%',
//         '&:first-child': {
//             marginTop: 0,
//         },
//     },

//     [theme.screen.laptop]: {
//         maxWidth: pxToRem(897),

//         display: 'grid',
//         gridTemplateColumns: `repeat(2, ${pxToRem(SINGLE_COLUMN_WIDTH)})`,
//         columnGap: pxToRem(COLUMN_GAP_DESKTOP),
//         '& > div': {
//             marginTop: 'unset',
//             marginLeft: 0,
//         },
//     },
// });

export const SingleImageContainer: StyleRule = ({ theme }) => ({
    width: '100%',
    margin: '0 auto',

    [theme.screen.laptop]: {
        width: pxToRem(COLUMN_WIDTH_100),
    },
});

// export const DetailPageTagBarContainer: StyleRule = () => ({
//     marginTop: pxToRem(120),
// });
